// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"279":"a77247ec","438":"460796d1","469":"460796d1","497":"f11181d6","659":"460796d1"}[chunkId] + ".chunk.css";
};